<template>
    <div id="app">
        <view-logo />
        <view-profile class="container" />
        <div id="deco" class="black">Profile</div>
        <view-introduce class="container" />
        <view-skills class="container" />
        <view-project class="container" />
        <view-footer />
    </div>
</template>
<script>
import ViewLogo from "@/components/ViewLogo.vue";
import ViewProfile from "@/components/ViewProfile.vue";
import ViewIntroduce from "@/components/ViewIntroduce.vue";
import ViewSkills from "@/components/ViewSkills.vue";
import ViewProject from "@/components/ViewProject.vue";
import ViewFooter from "@/components/ViewFooter.vue";

export default {
    name: "App",
    components: {
        ViewLogo,
        ViewProfile,
        ViewIntroduce,
        ViewSkills,
        ViewProject,
        ViewFooter,
    },
    mounted() {
        var val = window.innerHeight + 560;
        var $deco = document.getElementById("deco");
        $deco.style.top = val + "px";
    },
};
</script>

<style>
body,
html {
    margin: 0;
    padding: 0;
    min-width: 1200px;
}
* {
    font-family: "NanumSquare", sans-serif;
    font-size: 1.04em;
}
.container {
    width: 1200px;
    margin: 180px auto 0;
}
.black {
    font-family: "Black Han Sans", sans-serif;
}
#app {
    position: relative;
    overflow-x: hidden;
}
#deco {
    position: absolute;
    font-size: 9em;
    color: #edb352;
    opacity: 0.2;
    right: -80px;
}
</style>
